import { axiosClient } from 'www/utils'
import type {
  ApiDoctorListResponseGet,
  ApiDoctorListParamsGetCount,
  ApiDoctorListResponseGetCount,
} from 'www/vue_components/common/TheFilters/doctors/api/apiDoctorList.types'

export default {
  get(url: string) {
    return axiosClient.get<ApiDoctorListResponseGet>(url)
  },
  getCount(params: ApiDoctorListParamsGetCount) {
    return axiosClient.get<ApiDoctorListResponseGetCount>('/api/town/doctor-list-count/', {
      params,
      paramsSerializer: {
        indexes: null,
      },
    })
  },
}
